import { useStore } from '@nanostores/solid'
import { createSignal, Show } from 'solid-js'
import { $debugForceEnded, setDebugForceEnded } from '~/store/debug-force-ended'

/** QA-only widget pinned under the top-nav countdown — the caller gates it
 *  on `isDebugEnv`, so it never renders in production builds. Minimized to a
 *  wrench chip by default. Copy stays unlocalized English on purpose. */
export function DebugTool() {
  const [expanded, setExpanded] = createSignal(false)
  const forceEnded = useStore($debugForceEnded)
  return (
    <div class="flex items-center gap-1 pb-2 pl-1">
      <button
        type="button"
        aria-label="Debug tool"
        onClick={() => setExpanded(!expanded())}
        class="grid size-6 place-items-center rounded-full bg-black/40 text-xs transition-transform duration-150 active:scale-90"
      >
        🔧
      </button>
      <Show when={expanded()}>
        <label class="flex h-6 cursor-pointer items-center gap-1.5 rounded-full bg-black/40 px-2 text-xs font-semibold text-white">
          <input
            type="checkbox"
            checked={forceEnded()}
            onChange={(e) => setDebugForceEnded(e.currentTarget.checked)}
            class="size-3.5 accent-[#E84741]"
          />
          Force ended
        </label>
      </Show>
    </div>
  )
}
